import React from "react";
import { useSelector } from "react-redux";
import "./OrderAmendmentConfirmationDialog.css";
import TelegramButton from "../Button/TelegramButton";
import TelegramText from "../Text/TelegramText";
import { mergeCartsForAmendment } from "../../utils/review-order";

function OrderAmendmentConfirmationDialog({
  isOpen,
  existingOrder,
  existingOrderItems,
  onConfirm,
  onCancel,
  onGoToOrderManagement,
}) {
  const cartItems = useSelector((state) => state.cartItems.cartItems);

  // Debug alerts to show the data when dialog opens
  React.useEffect(() => {
    if (isOpen) {
      // Alert 1: Show existing order items
      // const existingItemsText = existingOrderItems?.map(item => 
      //   `${item.brand} ${item.category} ${item.title || item.name || item.product_name || "Unknown"} (${item.quantity || item.expectedqty || 0})`
      // ).join('\n') || 'No existing items';
      // 
      // alert(`EXISTING ORDER ITEMS:\n${existingItemsText}`);

      // Alert 2: Show current cart items (these will be added to existing order)
      // const newItemsText = cartItems.map(item => 
      //   `${item.brand || ''} ${item.category || ''} ${item.title || item.name || "Unknown"} (${item.quantity || 0})`
      // ).join('\n') || 'No new items';
      // 
      // alert(`NEW ORDER ITEMS (to be added):\n${newItemsText}`);
    }
  }, [isOpen, existingOrderItems, cartItems]);

  if (!isOpen) return null;

  // Calculate total cost of existing order
  // const totalCost =
  //   existingOrderItems?.reduce((total, item) => {
  //     const price = parseFloat(item.price || item.salesprice || 0);
  //     const quantity = parseInt(item.quantity || item.expectedqty || 0);
  //     return total + price * quantity;
  //   }, 0) || 0;
  const totalCost = parseFloat(existingOrder?.totalcost || 0);

  const totalItems =
    existingOrderItems?.reduce((total, item) => {
      const quantity = parseInt(item.quantity || item.expectedqty || 0);
      return total + quantity;
    }, 0) || 0;

  return (
    <div className="amendment-dialog-overlay" onClick={onCancel}>
      <div className="amendment-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="amendment-dialog-header">
          <TelegramText className="amendment-dialog-title">
            Existing Order found with {totalItems} items.
          </TelegramText>
          <TelegramText className="amendment-dialog-subtitle">
            Order #{existingOrder?.orderNo || existingOrder?.orderno}
          </TelegramText>
        </div>

        <div className="amendment-dialog-content">
          <TelegramText className="amendment-dialog-description">
            Please choose how to proceed with your order:
          </TelegramText>

          <div className="amendment-dialog-order-summary">
            {/* <div className="amendment-dialog-section-title">
              <TelegramText>Existing Order Items:</TelegramText>
            </div> */}

            <div className="amendment-dialog-items">
              {existingOrderItems?.map((item, index) => {
                const title =
                  item.brand +
                  " " +
                  item.category +
                  " " +
                  (item.title ||
                    item.name ||
                    item.product_name ||
                    "Unknown Item");
                const quantity = parseInt(
                  item.quantity || item.expectedqty || 0
                );
                const price = parseFloat(item.price || item.sales_price || 0);

                return (
                  <div key={index} className="amendment-dialog-item">
                    <div className="amendment-dialog-item-details">
                      <span className="amendment-dialog-item-quantity">
                        {quantity}x
                      </span>
                      <span className="amendment-dialog-item-name">
                        {title}
                      </span>
                    </div>
                    <div className="amendment-dialog-item-price">
                      ${(price * quantity).toFixed(2)}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="amendment-dialog-total">
              <div className="amendment-dialog-total-row">
                <TelegramText className="amendment-dialog-total-label">
                  Total Cost:
                </TelegramText>
                <TelegramText className="amendment-dialog-total-amount">
                  ${totalCost.toFixed(2)}
                </TelegramText>
              </div>
            </div>
          </div>
        </div>

        <div className="amendment-dialog-actions">
          <TelegramButton
            className="amendment-dialog-cancel-btn"
            onClick={onCancel}
          >
            Cancel
          </TelegramButton>
          <TelegramButton
            className="amendment-dialog-primary-btn"
            onClick={() => {
              if (onGoToOrderManagement) {
                onGoToOrderManagement();
              }
            }}
          >
            Go to Order Management
          </TelegramButton>
          <TelegramButton
            className="amendment-dialog-confirm-btn amendment-dialog-disabled-btn"
            disabled={true}
            onClick={() => {
              // Disabled - show message about feature being unavailable
              // alert('This feature is currently not available. Please use "Go to Order Management" instead.');
            }}
          >
            Merge with Existing Order (Not Available)
          </TelegramButton>
        </div>
      </div>
    </div>
  );
}

export default OrderAmendmentConfirmationDialog;
